import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/helpdesk/settings')({
  beforeLoad: () => {
    // Redirect old settings route to profile
    throw redirect({ to: '/helpdesk/profile' })
  },
})
